(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ss-proyectos-solicitud', {
            parent: 'entity',
            url: '/solicitud',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                  templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud.html',
                  controller: 'SSProyectoSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {                    	
                        id: null,
                        nombre: null,
                        ambito: null,
                        semestres: null,
                        funcion: null,
                        modalidad: null,
                        area: null,
                        objetivosGenerales: null,
                        objetivosEspecificos: null,
                        beneficiarios: null,
                        recursosMateriales: null,
                        recursosHumanos: null,
                        recursosInfraestructura: null,
                        monto: 0,
                        viaticosAlimentos: false,
                        viaticosTransporte: false,
                        horarioPrestador: null,
                        induccion: null,
                        horasInduccion: 0,
                        supervisionInstrumentos: null,
                        supervisionPeriodicidad: null,
                        supervisionCriterios: null,                        
                        perfils: [],
                        respDePrestadors:[],
                        unidadesReceptoras: [{
                        	id: null,
                        	institucion: null,
                        	dependencia: null,
                        	unidadReceptora: null,
                        	direccion: null,
                        	email: null,
                        	telefono1: null,
                        	telefono2: null,
                        	fax: null,
                        	sector: null, 
                        }],
                        respDeProyectos: [{
                        	id: null,
                        	nombres: null,
                        	primerApellido: null,
                        	segundoApellido: null,
                        	sexo: null,
                        	titulo: null,
                        	email: null,
                        	telefono: null,
                        	telefono2: null,
                        }],
                        cveProgramaSII: null,
                        cveProgAprobadoSII: null,
                        descripcion: null,
                        estatus: null,
                        inicioVigencia: null,
                        finVigencia: null,
                        justificacion: null,
                        meta: null,
                        calendarizacion: null,
                        altaReg: null,
                        bajaReg: null,
                        ultActReg: null,
                        activo: null,
                        usuarioUltAct: null,
                        aprobadoanteriormente: false,
                        proyectoidanterior: null
                    };
                },
                selectedTab: function () {
                	return 0;
                },
                section: function () {
                	return 1;
                },
            }
        })
        .state('ss-proyecto-solicitud', {
            parent: 'ss-proyectos',
            url: '/solicitud/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud.html',
                    controller: 'SSProyectoSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 0;
                }
            }
        })
        .state('ss-proyecto-seguimiento', {
            parent: 'ss-proyectos',
            url: '/seguimiento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'SSProyectos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/s-s-proyecto/ss-proyecto-solicitud/ss-proyecto-solicitud.html',
                    controller: 'SSProyectoSolicitudController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'SSProyecto', function($stateParams, SSProyecto) {
                    return SSProyecto.getSolicitud({id : $stateParams.id}).$promise;
                }],
                selectedTab: function () {
                	return 1;
                }
            }
        })
    }
})();
